import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/createTemplateDisabled.svg'
import _imports_1 from '@/assets/createTemplate.svg'
import _imports_2 from '@/assets/startHoverIcon.svg'
import _imports_3 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "px-5 pt-3 pb-2 mb-5" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_3 = { class: "flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "items-center justify-between flex" }
const _hoisted_7 = { class: "title flex items-center" }
const _hoisted_8 = { class: "mt-5 flex flex-wrap gap-3" }
const _hoisted_9 = { class: "flex items-center justify-center flex-col" }
const _hoisted_10 = { class: "flex justify-center mb-1" }
const _hoisted_11 = {
  key: 0,
  src: _imports_0,
  alt: "createTemplate"
}
const _hoisted_12 = {
  key: 1,
  src: _imports_1,
  alt: "createTemplate"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "flex justify-between mt-1.5" }
const _hoisted_16 = { class: "gap-2 flex justify-center mt-1" }
const _hoisted_17 = { class: "text-xs font-semibold" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  src: _imports_2,
  alt: "createTemplate",
  class: "hover-img"
}
const _hoisted_21 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_22 = { class: "popup-business flex-1 overflow-y-auto" }
const _hoisted_23 = { class: "flex flex-col h-full" }
const _hoisted_24 = { class: "flex-1 overflow-auto hide-scrollbar" }
const _hoisted_25 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_26 = { class: "formcontainer flex flex-col" }
const _hoisted_27 = { class: "upperspacing" }
const _hoisted_28 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_29 = {
  key: 0,
  class: "error-text"
}
const _hoisted_30 = { class: "row flex flex-row upperspacing w-full gap-4" }
const _hoisted_31 = { class: "w-1/2" }
const _hoisted_32 = ["min"]
const _hoisted_33 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_34 = {
  key: 0,
  class: "error-text"
}
const _hoisted_35 = { class: "w-1/2" }
const _hoisted_36 = ["min"]
const _hoisted_37 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_38 = {
  key: 0,
  class: "error-text"
}
const _hoisted_39 = { class: "" }
const _hoisted_40 = { class: "upperspacing" }
const _hoisted_41 = { class: "mt-2" }
const _hoisted_42 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_43 = {
  key: 0,
  class: "error-text"
}
const _hoisted_44 = { class: "upperspacing" }
const _hoisted_45 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_46 = {
  key: 0,
  class: "error-text"
}
const _hoisted_47 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dotsloader = _resolveComponent("dotsloader")!
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dotsLoading && _ctx.pageStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_dotsloader)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.presentProcessObj.businessProcessName), 1)
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "mt-3" }, [
            _createElementVNode("p", { class: "text-xs" }, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "cardheight flex items-center justify-center card h-auto boxShadow bg-white py-2.5 cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.isAddDisabled && _ctx.addTemplate()))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.isAddDisabled)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                    : (_openBlock(), _createElementBlock("img", _hoisted_12))
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-sm font-semibold flex justify-center mt-2" }, "New Template", -1))
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedTemplateObject, (obj, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "cardheight card bg-white boxShadow p-3 cursor-pointer",
                onClick: ($event: any) => (_ctx.goToTemplateDetails(obj._id))
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["text-sm font-semibold h-10 mb-1.5", obj.title.length > 40 ? 'table-ellipsis' : ''])
                    }, _toDisplayString(obj.title), 3)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-xs gap-2 flex" }, [
                        _createTextVNode("Activities "),
                        _createElementVNode("div", null, ":")
                      ], -1)),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(obj.controls.length), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["image-container", { 'disabled': _ctx.isAddDisabled }]),
                      onClick: _withModifiers(($event: any) => (!_ctx.isAddDisabled && _ctx.startTaskPopup(obj)), ["stop"])
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.isAddDisabled ? require('@/assets/startDisabled.svg') : require('@/assets/start.svg'),
                        alt: "createTemplate",
                        class: "default-img"
                      }, null, 8, _hoisted_19),
                      (!_ctx.isAddDisabled)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_18)
                  ])
                ])
              ], 8, _hoisted_13))
            }), 128))
          ])
        ])),
    (_ctx.createTaskPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.createTaskPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("h1", {
                class: _normalizeClass(["w-1/2", _ctx.titleLength > 40? 'table-ellipsis1':''])
              }, _toDisplayString(_ctx.templateTitle), 3),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCloseAddPopup()))
              }, [...(_cache[16] || (_cache[16] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", {
                          for: "number",
                          class: "controllabel"
                        }, "Title", -1)),
                        _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "number",
                          class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.templateTaskObj.mainTaskName.$error }]),
                          placeholder: "Task Name",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.templateTaskObj.mainTaskName) = $event))
                        }, null, 2), [
                          [
                            _vModelText,
                            _ctx.templateTaskObj.mainTaskName,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.templateTaskObj.mainTaskName.$error )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (_ctx.v$.templateTaskObj.mainTaskName.required.$invalid )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "controllabel text-xs" }, "Start Date", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            class: _normalizeClass(["mt-2", {'is-invalid': _ctx.v$.templateTaskObj.startDate.$error,'inputboxstylingForSelectAtPopup': _ctx.templateTaskObj.startDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.templateTaskObj.startDate !== '' }]),
                            onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            min: _ctx.today,
                            onkeydown: "return false",
                            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkForStartDate && _ctx.checkForStartDate(...args))),
                            placeholder: "Select Start Date",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.templateTaskObj.startDate) = $event))
                          }, null, 42, _hoisted_32), [
                            [_vModelText, _ctx.templateTaskObj.startDate]
                          ]),
                          (_ctx.v$.templateTaskObj.startDate.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                (_ctx.v$.templateTaskObj.startDate.required.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _cache[20] || (_cache[20] = _createElementVNode("label", { class: "controllabel text-xs" }, "Due Date", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            class: _normalizeClass(["mt-2", {'is-invalid': _ctx.v$.templateTaskObj.dueDate.$error,'inputboxstylingForSelectAtPopup': _ctx.templateTaskObj.dueDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.templateTaskObj.dueDate !== ''  }]),
                            onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            onkeydown: "return false",
                            min: _ctx.templateTaskObj.startDate||_ctx.today,
                            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkForStartDate && _ctx.checkForStartDate(...args))),
                            placeholder: "Select Start Date",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.templateTaskObj.dueDate) = $event))
                          }, null, 42, _hoisted_36), [
                            [_vModelText, _ctx.templateTaskObj.dueDate]
                          ]),
                          (_ctx.v$.templateTaskObj.dueDate.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                (_ctx.v$.templateTaskObj.dueDate.required.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "controllabel text-xs" }, "Assigned To", -1)),
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.templateTaskObj.assignee,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.templateTaskObj.assignee) = $event)),
                              suggestions: _ctx.userOptions,
                              onComplete: _ctx.asyncFind,
                              optionLabel: "label",
                              optionValue: "value",
                              appendTo: "self",
                              placeholder: "Assigned to",
                              class: _normalizeClass(["p-inputtext-sm systemsstyling custom-multiselect userSelect", {
                                                    'p-invalid': _ctx.v$.templateTaskObj.assignee.$error,
                                                    'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
                                                    'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '' 
                                                }])
                            }, {
                              empty: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                _createElementVNode("span", null, "No Members Found", -1)
                              ]))]),
                              _: 1
                            }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                            (_ctx.v$.templateTaskObj.assignee.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  (_ctx.v$.templateTaskObj.assignee.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _cache[23] || (_cache[23] = _createElementVNode("label", { class: "controllabel text-xs" }, "Description", -1)),
                        _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          name: "Description",
                          placeholder: "Description",
                          id: "",
                          class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.templateTaskObj.description.$error }]),
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.templateTaskObj.description) = $event))
                        }, null, 2), [
                          [
                            _vModelText,
                            _ctx.templateTaskObj.description,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.templateTaskObj.description.$error )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              (_ctx.v$.templateTaskObj.description.required.$invalid )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["mr-2", (JSON.stringify(_ctx.templateTaskObjDummy) == JSON.stringify(_ctx.templateTaskObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                      disabled: _ctx.clickOnButton,
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onCancelbtn()))
                    }, "Reset", 10, _hoisted_48),
                    _createElementVNode("button", {
                      class: _normalizeClass(["", (JSON.stringify(_ctx.templateTaskObjDummy) == JSON.stringify(_ctx.templateTaskObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                      disabled: _ctx.clickOnButton,
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clickOnSubmitToCreateTask()))
                    }, "Save", 10, _hoisted_49)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}